import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbTableApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbTable';
    }

    /**
     * 根据ErmodelId 查询数据
     * @param ermodelId 
     * @returns 
     */
    public async getDbTableListByErModelId(ermodelId: number) {
        return await this.send({ ermodelId }, 'getDbTableListByErModelId', Methods.GET);
    }

    /**
     * 保存数据
     * @param datas 
     * @returns 
     */
    public async dbTableSaveOrUpdate(datas) {
        return await this.send(datas, 'dbTableSaveOrUpdate', Methods.POST);
    }

    /**
     * 移动DbTable
     * @param id 
     * @param erModelId 
     * @returns 
     */
    public async moveDbTable(id, erModelId) {
        return await this.send({ id, erModelId }, 'moveDbTable', Methods.POST);
    }

    /**
     * 删除表
     * @param id 
     */
    public async deleteDbTable(id) {
        return await this.send({}, "deleteDbTable?id=" + id, Methods.POST);
    }

        /**
     * 获取表数据
     * @param dbId
     * @param devProd
     */
    public async getTableByDevProd(dbId, devProd:any='dev') {
        return await this.send({ dbId, devProd }, 'getTableByDevProd', Methods.GET);
    }

}